import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreatePrivateLessonTemplate } from "../api/queries";
import { PrivateLessonTemplateForm } from "../ui/PrivateLessonTemplateForm";

export function PrivateLessonTemplateCreatePage() {
  const nav = useNavigate({ from: "/app/private-lessons/templates/create" });
  const createTemplate = useCreatePrivateLessonTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "Template ແພັກເກດຮຽນສ່ວນຕົວ",
              to: "/app/private-lessons/templates",
            },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ Private Lesson Template
            </h2>
            <p className="text-muted-foreground">
              ສ້າງ template ແພັກເກດຮຽນສ່ວນຕົວໃໝ່ໃນລະບົບ.
            </p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/private-lessons/templates" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <PrivateLessonTemplateForm
            onSubmit={async (vals) => {
              try {
                const result = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/private-lessons/templates/$id",
                  params: { id: result.id },
                });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
